import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { formatDatetimeJST } from '../../../../utils/dateFormat'
import { Button, Panel } from '../../../atoms'
import { EditTable } from '../../../organisms'
import SidebarLayout from '../../_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  guide_announcements: {
    guide_announcements: IJsonResponse
  }
  categories: IJsonResponse
  user: IJsonResponse
}

const COLUMNS = [
  {
    name: I18n.t('generic.id'),
    field: 'id',
    required: false,
    readOnly: true,
    className: 'small-col-left',
  },
  {
    name: I18n.t('generic.title'),
    field: 'title',
    required: true,
  },
  {
    name: 'カテゴリ',
    field: 'category',
    required: false,
    renderElement: record => <div>{record.category ? record.category.display_name : '-'}</div>,
  },
  {
    name: 'Active',
    field: 'is_active',
    required: false,
    className: 'small-col',
    renderElement: record => (
      <div style={{ textAlign: 'center' }}>{record.is_active ? '◯' : '✕'}</div>
    ),
  },
  {
    name: 'アプリお知らせ',
    field: 'is_announcement',
    required: false,
    className: 'small-col',
    renderElement: record => (
      <div style={{ textAlign: 'center' }}>{record.is_announcement ? '◯' : '✕'}</div>
    ),
  },
  {
    name: 'メール通知',
    field: 'is_email',
    required: false,
    className: 'small-col',
    renderElement: record => (
      <div style={{ textAlign: 'center' }}>{record.is_email ? '◯' : '✕'}</div>
    ),
  },
  {
    name: 'プッシュ通知',
    field: 'is_mobile_push',
    required: false,
    className: 'small-col',
    renderElement: record => (
      <div style={{ textAlign: 'center' }}>{record.is_mobile_push ? '◯' : '✕'}</div>
    ),
  },
  {
    name: '公開日時',
    field: 'published_at',
    required: false,
    renderElement: record => <div>{formatDatetimeJST(record.published_at)}</div>,
  },
]

const AgentGuideAnnouncementsIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('アプリお知らせ 一覧')

  const { data: userData } = utilService.getDataFromJson(props.user)
  const { data: guideAnnouncementsList, pagination } = agentService.getDataFromJson(
    props.guide_announcements.guide_announcements
  )

  const [guideAnnouncements, setGuideAnnouncements] = React.useState(guideAnnouncementsList)

  const handleDelete = React.useCallback(
    async id => {
      const { flush } = await agentService.deleteGuideAnnouncement(id)
      window.flashMessages.addMessage({
        text: flush.message,
        type: flush.type,
      })
      setGuideAnnouncements(guideAnnouncements.filter(t => t.id !== id))
    },
    [guideAnnouncements]
  )

  const handleClickDelete = id => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(id)
    }
  }

  return (
    <SidebarLayout user={userData}>
      <Wrapper>
        <Panel
          title={
            <Heading>
              <span>アプリお知らせ 一覧</span>
              <Button primary={true}>
                <a href="/agent/guide_announcements/new">{I18n.t('generic.create')}</a>
              </Button>
            </Heading>
          }
        >
          <EditTable
            editable={true}
            columns={COLUMNS}
            records={guideAnnouncements}
            pagination={pagination}
            handleDelete={handleClickDelete}
            getEditLink={({ id }) => `/agent/guide_announcements/${id}/edit`}
            getRowLink={record => `/agent/guide_announcements/${record.id}`}
          />
        </Panel>
      </Wrapper>
    </SidebarLayout>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: 22px 40px 80px 46px;

  .Panel {
    max-width: none;
  }

  .Table .Table_Header,
  .Table .Table_Data {
    padding-left: 8px;
    padding-right: 8px;
  }

  .Table .small-col-left {
    min-width: 40px;
    width: 40px;
  }

  .Table .small-col {
    min-width: 64px;
    width: 64px;
    text-align: center;
  }
`

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

export default AgentGuideAnnouncementsIndex
